// extracted by mini-css-extract-plugin
export var addressFields = "_jq-0";
export var animationContainer = "_jq-1";
export var footer = "_jq-2";
export var lineItems = "_jq-3";
export var modalContent = "_jq-4";
export var orderName = "_jq-5";
export var strong = "_jq-6";
export var warning = "_jq-7";